<template>
  <!-- 抽签活动 -->
  <div class="page" v-if="detail.progress">
    <navigation
      :theme="{
        background: 'transparent',
        color: '#fff',
      }"
      arrTheme="white"
      :sticky="false"
    >
      <span>周三添财日</span>
      <span
        slot="right"
        class="rule-txt"
        @click="jumpRule"
      >活动规则</span>
    </navigation>

    <!-- header -->
    <div class="header">
      <div class="today-step">
        今日 <span>{{detail.userNum}}</span> 位用户已沾好运，上上签库存进度 <span>{{detail.progress}}%</span>
      </div>
      <div class="header-title"><img src="./images/title@2x.png" /></div>

      <div class="end-time">
        <span>距离活动结束仅剩</span>
        <van-count-down :time="countDownTime">
          <template #default="timeData">
            <span class="block">{{ timeData.hours }}</span>
            <span class="colon">小时</span>
            <span class="block">{{ timeData.minutes }}</span>
            <span class="colon">分</span>
          </template>
        </van-count-down>
      </div>
    </div>

    <!-- 活动动效 -->
    <div
      class="active-container"
      :class="{showBack,assemble}"
      v-if="detail && detail.progress"
    >
      <div
        class="active-detail"
        v-if="!detail.activeRecordStatus"
        data-sensors-exposure-event-name="Element_Exposure"  
        data-sensors-exposure-property-caseId="TO_BE_START"
      >
        <div
          class="item"
          v-for="item in cardList"
          :key="item"
          :class="{shake: activeItem === item}"
          data-sensors-click
          @click="handleDraw(item)"
        >
          <div class="front card-face">
            <img :src="require(`./images/${item}.png`)" />
          </div>
          <div class="back card-face">
            <img :src="require(`./images/b${item}.png`)" />
          </div>
        </div>
      </div>
      <div
        class="active-detail"
        v-if="['NOT_USE', 'USED'].includes(detail.activeRecordStatus)"
        data-sensors-exposure-event-name="Element_Exposure"  
        :data-sensors-exposure-property-caseId="detail.activeRecordStatus"
      >
        &nbsp; <!--别删 -曝光占位符 -->
        <Card :type="detail.card" />
      </div>
      <div class="btn-container">
        <template v-if="!detail.activeRecordStatus">
          <img
            src="./images/btn_shishishouqi@2x.png"
            class="btn-shuffle"
            @click="handleShuffle"
            data-sensors-click
            v-if="!showBack"
          />
          <span v-else class="back-tips">点击任意卡片沾取好运</span>
          <div class="finger" :class="{showBack}">
            <img src="./images/img_shou@2x.png" >
          </div>
        </template>
        <img
          src="./images/btn_not_use.png"
          class="btn-not-use"
          @click="withdraw"
          data-sensors-click
          v-if="detail.activeRecordStatus === 'NOT_USE'"
        />
        <img
          src="./images/btn_used.png"
          v-if="detail.activeRecordStatus === 'USED'"
        />
      </div>
    </div>

    <withdraw-user-flipper
      v-if="detail.rollingData && detail.rollingData.length"
      :background="'linear-gradient( 270deg, #FFC3BE 0%, #F7C91B 100%)'"
      :amountTextColor="'#FF4633'"
      :users="detail.rollingData"
    />

    <img
      src="./images/img_zhanhaoyun@2x.png"
      class="footer-img"
    >

    <!-- 抽奖结果 -->
    <div
      class="dialog-card"
      v-if="showDialog"
      :class="{showDialog}"
      data-sensors-exposure-event-name="PopupDisplay"  
      :data-sensors-exposure-property-caseId="detail.card"
    >
      <i class="mask"></i>
      <img
        src="./images/img_guang@2x.png"
        class="bg"
      >
      <Card :type="detail.card" />
      <img
        src="./images/btn_lixiang@2x.png"
        class="dialog-btn"
        @click="$router.push('/middle/limit')"
        data-sensors-click
      >
      <img
        src="./images/btn_close@2x.png"
        class="close"
        @click="showDialog= false"
        data-sensors-click
      >
    </div>
  </div>
</template>

<script>
import withdrawUserFlipper from '../components/withdraw-user-flipper.vue'
import Card from '../components/card.vue'
import { mapActions } from 'vuex'
import _ from 'lodash'
export default {
  components: {
    withdrawUserFlipper,
    Card
  },
  data () {
    return {
      showDialog: false,
      detail: {
        residue: 0,
        rollingData: []
      },
      cardList: [1, 2, 3, 4, 5, 6],
      showBack: false,
      pendding: false,
      assemble: false,
      activeItem: null,
      type: 'RAISE_1000'
    }
  },
  mounted () {
    this.getDetail()
    this.$bus.$emit('ready')
  },
  computed: {
    countDownTime () {
      // 获取当前时间戳
      const now = new Date().getTime()
      return this.detail.residue - now
    }
  },
  methods: {
    ...mapActions('activities', ['getActivityDetail', 'receiveActive']),
    handleDraw (item) {
      if (!this.showBack) return
      if (this.pendding) return
      this.$sensors.track('$WebClick', { caseid: 'Draw' })
      this.pendding = true
      this.activeItem = item
      setTimeout(() => {
        this.pendding = false
        this.activeItem = null
        this.lockQuota()
      }, 2000)
    },
    handleShuffle () {
      if (this.pendding) return
      this.pendding = true
      this.showBack = true
      setTimeout(() => {
        this.assemble = true
        this.cardList = _.shuffle(this.cardList)
        setTimeout(() => {
          this.assemble = false
        }, 500)
      }, 500)
      this.pendding = false
    },
    jumpRule () {
      this.$router.push({
        path: '/act-four-rules'
      })
    },
    async lockQuota () {
      if (window.pending) return
      window.pending = true
      const { success } = await this.receiveActive({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_DIVINATION_CARD'
      })
      window.pending = false
      if (success) {
        await this.getDetail()
        this.showDialog = true
      }
    },
    // 获取活动详情
    async getDetail () {
      const { success, data } = await this.getActivityDetail({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_DIVINATION_CARD'
      })
      if (success) {
        this.detail = data || {}
      } else {
        setTimeout(() => {
          this.$router.push('/')
        }, 2000)
      }
    },
    // 提现
    withdraw () {
      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.page {
  background: url("./images/bg.png") no-repeat;
  background-size: cover;
  min-height: 100vh;
  padding-bottom: 30px;
  .dialog-card {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999999;

    @keyframes show {
      0% {
        transform: translate(-50%, -50%) scale(0.3) rotateY(-180deg);
      }
      100% {
        transform: translate(-50%, -50%) scale(1) rotateY(0);
      }
    }
    .mask {
      background: rgba(0, 0, 0, 0.9);
      position: absolute;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
    }
    /deep/.card-detail {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: -100px;
    }
    &.showDialog {
      .dialog-btn {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin-top: 350px;
        width: 520px;
        height: 160px;
        animation: show 1s forwards;
      }
    }

    .bg {
      width: 710px;
      height: 710px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: -100px;
      animation: rotates 1s infinite linear;
    }
    @keyframes rotates {
      0% {
        transform: translate(-50%, -50%) rotateZ(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotateZ(360deg);
        // transform-origin: 50% 50%;
      }
    }
    .close {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: 460px;
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
  }

  .footer-img {
    width: 302px;
    display: block;
    margin: 66px auto;
  }

  .rule-txt {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
    color: #ffffff;
    line-height: 40px;
    text-align: right;
    font-style: normal;
    margin-right: 40px;
    display: block;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .today-step {
      font-size: 26px;
      color: #ffffff;
      line-height: 37px;
      text-align: center;
      margin-top: 40px;
      background: rgba(255, 255, 255, 0.2);
      width: 650px;
      padding: 11px;
      border-radius: 10px;
      span {
        color: #ffdc54;
      }
    }
    .header-title {
      margin-top: 40px;
      img {
        width: 528px;
      }
    }
    .end-time {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      color: #ffffff;
      line-height: 37px;
      display: flex;
      justify-content: center;
      margin-top: 17px;
      .van-count-down {
        display: flex;
        align-items: center;
        .block {
          color: #ff4633;
          background-color: #ffd9d9;
          border-radius: 4px;
          font-size: 26px;
          width: 36px;
          height: 36px;
          line-height: 36px;
          margin-left: 9px;
          margin-right: 9px;
          text-align: center;
          display: block;
        }
        .colon {
          color: #fff;
          font-size: 26px;
        }
      }
    }
  }

  .active-container {
    background: url("./images/img_di@2x.png") no-repeat center bottom;
    background-size: 650px 298px;
    width: 650px;
    margin: 42px auto 35px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 780px;
    position: relative;
    .btn-container {
      position: absolute;
      width: 520px;
      height: 160px;
      bottom: 35px;
      .back-tips {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 44px;
        color: #FFFFFF;
        line-height: 62px;
        text-align: center;
        display: block;
        padding-top: 40px;
      }
      &>img {
        width: 100%;
      }
      .finger {
        position: absolute;
        right: 30px;
        top:70px;
        width: 80px;
        animation: finger 0.3s infinite alternate;
        transition: all 2.5s;
        &.showBack {
          top:-1.5rem;
          right: -20px;
        }
        img {
          width: 100px;
        }
        @keyframes finger {
          to {
            transform: translateY(-10px) scale(0.9)
          }
        }
      
      }
    }
    &.showBack {
      .active-detail .item {
        transform: rotateY(-180deg);
      }
    }
    &.assemble {
      .active-detail .item {
        left: 50%;
        margin-left: -85px;
        top: 160px;
      }
    }
  }
  .active-detail {
    display: flex;
    flex-wrap: wrap;
    perspective: 1000px;
    padding: 0 20px;
    width: 100%;
    position: relative;
    /deep/.card-detail {
      width: 416px;
      height: 570px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    
      &.type_speed {
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 38px;
          color: #dd752d;
          line-height: 48px;
          width: 1em;
          display: block;
          margin-top: 70px;
          margin-bottom: 10px;
        }
      }
      &.type_funds {
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 38px;
          color: #dd752d;
          line-height: 54px;
          width: 1em;
          display: block;
          margin-top: 70px;
          margin-bottom: 30px;
        }
      }
      &.type_raise {
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 34px;
          color: #dd752d;
          line-height: 44px;
          display: block;
          margin-top: 130px;
          margin-bottom: 70px;
          text-align: center;
        }
      }
    }
    .item {
      width: 170px;
      height: 255px;
      transition: all 0.3s;
      position: absolute;
      transform-style: preserve-3d; /* 保持3D空间中的子元素原样 */
      &.shake {
        animation: shake 0.5s infinite;
      }
      @keyframes shake {
        0% {
          transform: rotateY(-180deg) rotate(0deg);
        }
        25% {
          transform: rotateY(-180deg) rotate(10deg);
        }
        50% {
          transform: rotateY(-180deg) rotate(-10deg);
        }
        75% {
          transform: rotateY(-180deg) rotate(10deg);
        }
        100% {
          transform: rotateY(-180deg) rotate(0deg);
        }
      }
      .card-face {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        transform-style: preserve-3d;
        backface-visibility: hidden; /* 隐藏背面在翻转时的短暂显示 */
        & > img {
          width: 100%;
        }
      }

      .back {
        transform: rotateY(180deg);
      }

      &:nth-of-type(1) {
        transition-delay: 0s;
        left: 40px;
        top: 0;
      }
      &:nth-of-type(2) {
        transition-delay: 0s;
        left: 240px;
        top: 0;
      }
      &:nth-of-type(3) {
        transition-delay: 0s;
        left: 440px;
        top: 0;
      }
      &:nth-of-type(4) {
        transition-delay: 0s;
        left: 40px;
        top: 275px;
      }
      &:nth-of-type(5) {
        transition-delay: 0s;
        left: 240px;
        top: 275px;
      }
      &:nth-of-type(6) {
        transition-delay: 0s;
        left: 440px;
        top: 275px;
      }
    }
  }
}
</style>
